import React, { useState, useEffect } from 'react'
import { strCol, numCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import { connect } from 'react-redux'
import { Select, Button, Input } from 'antd'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core/selectors'
import * as api from '../../../api/pgads'
import CommonScreen from '../CommonScreen'

const title = 'User Message'

const UserMessage = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [categoryList, setCategoryList] = useState([])

  useEffect(() => {
    api
      .getMessageCategory(apiTargetInfo)
      .fork(console.log, data => setCategoryList(data))
  }, [apiTargetInfo])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        width: '100%',
        display: 'flex',
      }}
    >
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '20px',
        }}
      >
        Category :
      </div>
      <Select
        style={{ width: '200px' }}
        value={insertData.category}
        onChange={e => setInsertData({ ...insertData, category: e })}
      >
        {categoryList.map(({ category }) => (
          <Select.Option key={category}>{category}</Select.Option>
        ))}
      </Select>
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '50px',
        }}
      >
        User Message :
      </div>
      <Input
        style={{ width: '300px' }}
        value={insertData.message}
        onChange={e =>
          setInsertData({ ...insertData, message: e.target.value })
        }
        maxLength={15}
      />
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button type="danger" style={{ marginLeft: '50px' }} onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={UserMessageHeaders}
      saveTask={api.saveUserMessage}
      retrieveTask={api.getUserMessage}
      deleteTask={api.deleteUserMessage}
      altBy={d => d.unitId}
      autoRetrieve
      initialSortOptions={UserMessageHeadersSort}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      defaultInsertData={{ adminUser: false }}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={30}
      withUpdate={false}
      skipValidation
      isEditableGrid={false}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(UserMessage)

export const UserMessageHeaders = [
  strCol({
    ident: 'username',
    display: 'User Name',
    isKey: true,
    alignment: 'left',
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'message',
    display: 'Message',
    width: 450,
    alignment: 'left',
    sortOrder: 'asc',
    ellipsis: true,
    isEditable: false,
    isKey: true,
  }),
  numCol({
    ident: 'messageId',
    display: 'Message ID',
    displayFormat: '0',
    isKey: true,
    alignment: 'right',
    sortOrder: 'asc',
    isEditable: false,
  }),
  dateTimeCol({
    ident: 'datetime',
    display: 'Date Time',
    sortOrder: 'dsc',
    width: 150,
    isEditable: false,
    isKey: true,
  }),
  dateTimeCol({
    ident: 'ackDate',
    display: 'Acknowledged Date',
    width: 150,
    sortOrder: 'dsc',
    isEditable: false,
    isKey: true,
  }),
  modifierCol,
  modifiedDateCol,
]

export const UserMessageHeadersSort = [
  dateTimeCol({
    ident: 'datetime',
    display: 'Date Time',
    sortOrder: 'dsc',
    width: 150,
  }),
  strCol({
    ident: 'username',
    display: 'User Name',
    isKey: true,
    alignment: 'left',
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'message',
    display: 'Message',
    width: 450,
    alignment: 'left',
    sortOrder: 'asc',
    ellipsis: true,
  }),
  numCol({
    ident: 'messageId',
    display: 'Message ID',
    displayFormat: '0',
    isKey: true,
    alignment: 'right',
    sortOrder: 'asc',
  }),

  dateTimeCol({
    ident: 'ackDate',
    display: 'Acknowledged Date',
    width: 150,
    sortOrder: 'dsc',
  }),
  modifierCol,
  modifiedDateCol,
]
